import { CURRENCY, ACCOUNTING } from '../common/constants';

export default function isCurrencyStyle(style) {
    return style === CURRENCY || style === ACCOUNTING;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@telerik/kendo-intl/dist/es/numbers/is-currency-style.js
// module id = 146
// module chunks = 0